import type { Options as IconOptions } from 'ol/style/Icon'
import { Icon, Style } from 'ol/style'

import depotsSpriteSheet from '@/resources/map-markers/depots.png'

import { genericStyles } from '../../genericStyles'

const depotMarkerStylesCache: Map<string, Style> = new Map()

export const getDepotFeatureStyle = (
  marker: uui.domain.ui.map.markers.Depot,
  mode: uui.domain.ui.map.markers.MapStyles['depot']['mode'],
  selected: boolean = false,
) => {
  if (mode === 'off') return genericStyles.hidden

  const coordinates = selected ? marker.gridSelected : marker.grid

  const spriteSheetUrl = depotsSpriteSheet
  const cellSize = coordinates[2]
  const x = coordinates[0]
  const y = coordinates[1]

  const cacheId = `${x}_${y}`

  if (depotMarkerStylesCache.has(cacheId)) {
    const cachedStyle = depotMarkerStylesCache.get(cacheId)

    if (cachedStyle) return cachedStyle
  }

  const opts: IconOptions = {
    anchor: [0.5, 0.5],
    anchorOrigin: 'top-left',
    anchorYUnits: 'fraction',
    anchorXUnits: 'fraction',
  }

  const style = new Style({
    image: new Icon({
      src: spriteSheetUrl,
      crossOrigin: 'anonymous',

      scale: 0.5,
      opacity: 1.0,
      rotation: 0.0,
      rotateWithView: true,

      size: [cellSize, cellSize],
      offset: [x, y],

      ...opts,
    }),
  })

  depotMarkerStylesCache.set(cacheId, style)

  return style
}
